









































































































































































import Vue from "vue";
import { Component, Emit, Prop, Watch } from "vue-property-decorator";
import "./popups.less";
import "./_getting_discount.less";
import {get, getDiscountsData} from "../../services/webclient/webclient";
import { translate } from "../../services/translation/translation";
import progressbar from "@/components/progressbar/progressbar.vue";
import partnersMap from "@/components/partners-map/partners-map.vue";
import loginpopup from "@/components/getting-discount/login-popup";
import regpopup from "@/components/getting-discount/register-popup";

@Component({
  components: {
    loginpopup,
    regpopup,
    progressbar,
    partnersMap
  }
})
export default class GettingDiscount extends Vue {
  @Prop() selectedAnswer;
  @Prop() selectedCalcId;
  @Prop() selectedName;
  @Prop() sendYourData;
  @Prop() sendingProductsData;
  @Prop() systemId;
  @Prop() usePartners;
  @Prop() useMyBaumitUser;

  private data: any = {
    progressbar: {
      step0: "passed",
      step1: "passed",
      step2: "passed",
      step3: "active"
    },
    partners: [],
    city: "",
    phone: "",
    description: "",
    user_name: "",
    user_email: "",
    privacyPolicy: false,
    termConditions: false,
    newsletter: false
  };
  loggedIn = false;
  enabledNewsletter = false;
  targetGroups = [];

  constructor() {
    super();
  }

  mounted() {
    this.scrolltoTop();

    let self = this;
    get("/calculator/getTargetGroups").then(res => {
      self.targetGroups = res.targetGroups;
    });

    if ($("#calculator-wrapper").data("loggedin") == 1) {
      self.loggedIn = true;
    }
    if ($("#calculator-wrapper").data("enableneswletter") == 1) {
      self.enabledNewsletter = true;
      self.data.newsletter = true;
    }
  }

  trans(key) {
    return translate(key);
  }

  public gettingDiscounts() {
    if (this.isValidForm()) {
      let data = {};
      data['data'] = this.sendYourData;
      data['type_of_construction'] = '0';
      data['system_id'] = this.systemId;
      data['products'] = this.sendingProductsData;
      data['city'] = this.data.city;
      data['retailers'] = this.data.partners;
      data['phone'] = this.data.phone;
      data['description'] = this.data.description;
      data['privacyPolicy'] = this.data.privacyPolicy;
      data['termConditions'] = this.data.termConditions;
      data['newsletter'] = this.data.newsletter;
      data['user_name'] = this.data.user_name;
      data['user_email'] = this.data.user_email;

      getDiscountsData(data, this.selectedCalcId).then(data => {
        if(data.Status == 1){
          this.onNextToThanks(1);
        }
      }).catch(err => console.warn(err));

    }
  }

  isValidForm() {
    let isValid = true;
    let goTo = true;

    /*Selected Parrner*/
    if ((this.data.partners.length == 0 && this.usePartners) || this.data.partners.length > 3) {
      $("#map").addClass("error");
      this.goToError("#map");
      isValid = false;
    }else{
      $("#map").removeClass("error");
    }


    if(!this.useMyBaumitUser){
      /*required user_name*/
      if (this.data.user_name.length < 1) {
        $("input[name=user_name]").addClass("error");
        isValid = false;
        if (goTo) {
          goTo = false;
          this.goToError("input[name=user_name]");
        }
      } else {
        $("input[name=user_name]").removeClass("error");
      }
      /*required user_email*/
      if (this.data.user_email.length < 1) {
        $("input[name=user_email]").addClass("error");
        isValid = false;
        if (goTo) {
          goTo = false;
          this.goToError("input[name=user_email]");
        }
      } else {
        $("input[name=user_email]").removeClass("error");
      }
    }


    /*required city*/
    if (this.data.city.length < 1) {
      $("input[name=city]").addClass("error");
      isValid = false;
      if (goTo) {
        goTo = false;
        this.goToError("input[name=city]");
      }
    } else {
      $("input[name=city]").removeClass("error");
    }
    /*required phone*/
    if (this.data.phone.length < 1) {
      $("input[name=phone]").addClass("error");
      isValid = false;
      if (goTo) {
        goTo = false;
        this.goToError("input[name=phone]");
      }
    } else {
      $("input[name=phone]").removeClass("error");
    }
    /*required description*/
    /* elvileg nem kötelező
    if(this.data.description.length < 10){
      $('textarea[name=description]').addClass('error');
      isValid = false;
      if(goTo){
        goTo = false;
        this.goToError('textarea[name=description]');
      }
    }else{
      $('textarea[name=description]').removeClass('error');
    }
    */
    /*required privacyPolicy*/
    if (!this.useMyBaumitUser && !this.data.privacyPolicy) {
      $('span[for="privacyPolicy"]').addClass("error");
      isValid = false;
      if (goTo) {
        goTo = false;
        this.goToError('span[for="privacyPolicy"]');
      }
    } else {
      $('span[for="privacyPolicy"]').removeClass("error");
    }

    /*required termConditions*/
    if (!this.useMyBaumitUser && !this.data.termConditions) {
      $('span[for="termConditions"]').addClass("error");
      isValid = false;
      if (goTo) {
        goTo = false;
        this.goToError('span[for="termConditions"]');
      }
    } else {
      $('span[for="termConditions"]').removeClass("error");
    }

    return isValid;
  }
  scrolltoTop() {
    $(".getting-discount").fadeIn(300, function() {
      $("html, body").animate(
        {
          scrollTop: $(".getting-discount").offset().top - 144
        },
        500,
        "linear"
      );
    });
  }
  goToError(input) {
    $(input).fadeIn(300, function() {
      $("html, body").animate(
        {
          scrollTop: $(input).offset().top - 144
        },
        500,
        "linear"
      );
    });
  }

  @Watch("login", { immediate: true, deep: true })
  onLogin(logged) {
    this.loggedIn = logged;
    (window as any).onCreatedPartnersMap = true;
  }
  @Watch("registered", { immediate: true, deep: true })
  onRegistered(logged) {
    this.loggedIn = logged;
    (window as any).onCreatedPartnersMap = true;
  }
  @Watch("selectedPartners", { immediate: true, deep: true })
  onSelectedPartners(partners) {
    if (typeof partners != "undefined") {
      this.data.partners = partners;
    }
  }

  @Emit("nextToThanks")
  onNextToThanks(id) {}
}
